<div>
    <h2 class="userscreen-title"><button (click)="backClicked()" class="casino-back">Back</button> {{gameid}}</h2>
    <iframe [src]="gameurl" title="game" style="position:fixed; top:25px; left:0; bottom:0; right:0; width:100%; height:100%; border:none; margin:0; padding:0; overflow:hidden; z-index:999999;"></iframe>
</div>
